module.exports = __webpack_public_path__ + "drone-pat.png";